import { createStyles, makeStyles } from '@material-ui/core';

import { colorVariables } from '../../../../styles/colorVariables';
import { Sizes } from '../../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      padding: theme.spacing(3),
      paddingBottom: 4,
      backgroundColor: '#fff',
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      borderRadius: 20,
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      border: '1px solid rgba(0,0,0,0.1)',
      width: '100%',
      [theme.breakpoints.down(Sizes.mobile)]: {
        padding: '10px 4px 0 4px',
        marginBottom: 80,
      },
    },
    header: {
      marginBottom: theme.spacing(1),
    },
    subHeader: {
      marginBottom: theme.spacing(4),
      color: theme.palette.text.secondary,
    },
    card: {
      borderRadius: theme.shape.borderRadius * 1.5,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    trialCard: {
      backgroundColor: '#f8f9fa',
    },
    unlimitedCard: {
       backgroundColor: '#f8f9fa',
    },
    upgradeButton: {
      marginTop: theme.spacing(2),
      padding: theme.spacing(1.2, 3),
      borderRadius: theme.shape.borderRadius,
      fontWeight: 600,
      fontSize: '0.9rem',
    },
    planTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing(1),
    },
    trialBadge: {
      color: '#dc3545',
      fontSize: '0.8rem',
      fontWeight: 600,
    },
    cardTitle: {
        fontWeight: 600,
    },
    cardSubtitle: {
        fontWeight: 600,
        marginBottom: theme.spacing(1.5),
    },
    cardText: {
        color: theme.palette.text.secondary,
    },
    listItemIcon: {
      minWidth: 'auto',
      marginRight: theme.spacing(1.5),
      color: theme.palette.success.main, // Use theme color
      display: 'flex',
      alignItems: 'center',
    },
    listItemText: {
      '& .MuiListItemText-primary': {
         fontSize: '0.95rem',
         color: theme.palette.text.secondary,
      },
    },
    compareTitleContainer: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      userSelect: 'none',
      [theme.breakpoints.down(Sizes.mobile)]: {
        marginLeft: 4,
      },
    },
    collapseContainer: {
      marginTop: 20,
      [theme.breakpoints.down(Sizes.mobile)]: {
        marginBottom: 10,
        marginTop: 0,
        '&.MuiCollapse-entered': {
          marginTop: 20,
        }
      },
    },
    compareTitle: {
      fontWeight: 700,
      fontSize: 20,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 16,
      },
    },
    compareIcon: { // Style for the expand/collapse icon
      marginLeft: theme.spacing(1),
    },
    tableContainer: {
      '&.MuiTableContainer-root': {
        border: `1px solid ${theme.palette.divider}`,
        overflow: 'visible',
      }
    },
    tableHead: {
      backgroundColor: '#CFD7E680',
    },
    tableHeadCell: {
      '&.MuiTableCell-root': {
        fontWeight: 700,
        textAlign: 'center',
        padding: theme.spacing(1.5, 2),
        borderBottom: `1px solid ${theme.palette.divider}`,
        borderRight: `1px solid ${theme.palette.divider}`,
        color: theme.palette.text.primary,
        fontSize: 16,
        backgroundColor: '#E7EBF3',
        '&:last-child': { // Remove right border from last header cell
          borderRight: 0,
        },
        [theme.breakpoints.down(Sizes.mobile)]: {
          fontSize: 12,
        },
      }
    },
    tableCell: {
      '&.MuiTableCell-root': {
        textAlign: 'center',
        padding: '8px 16px',
        borderBottom: `1px solid ${theme.palette.divider}`,
        borderRight: `1px solid ${theme.palette.divider}`, 
        fontSize: 14,
        '&:last-child': { // Remove right border from last body cell in row
          borderRight: 0,
        },
        [theme.breakpoints.down(Sizes.mobile)]: {
          fontSize: 11,
          padding: '8px 0px',
        },
      }
    },
    tableRow: {
       '&:last-child td, &:last-child th': { borderBottom: 0 },
       '&:hover': {
          backgroundColor: theme.palette.action.hover,
       }
    },
    featureCell: {
      textAlign: 'center',
      fontWeight: 400,
      fontSize: 14,
      color: colorVariables.navy,
    },
    checkIcon: {
      color: '#40C369',
    },
    closeIcon: {
      color: '#F96767',
    },
    recommendedChipTable: {
      backgroundColor: '#F96767',
      color: '#fff',
      fontWeight: 'bold',
      fontSize: 11,
      height: 'auto',
      padding: theme.spacing(0.3, 0.8),
      position: 'absolute',
      top: -30,
      right: 0,
      zIndex: 1,
      width: '100%',
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      boxShadow: '-7px 0 4px 0px rgba(0,0,0,0.05), 7px 0 4px 0px rgba(0,0,0,0.05), 0 -7px 4px 0px rgba(0,0,0,0.05)',
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 7,
        padding: theme.spacing(0.3, 0),
      },
    },
    recommendedChipCard: {
      backgroundColor: '#dc3545',
      color: '#fff',
      fontWeight: 'bold',
      fontSize: '0.7rem',
      height: 20,
      padding: theme.spacing(0, 1),
      marginLeft: theme.spacing(1),
      borderRadius: theme.shape.borderRadius / 2,
    },
    recommendedChipIcon: {
      color: '#fff',
    },
    unlimitedColumn: {
      '&.MuiTableCell-root': {
        backgroundColor: '#FFF6D3',
        position: 'relative',
        zIndex: 10,
        // Updated boxShadow for left/right edges only
        boxShadow: '-7px 0 4px 0px rgba(0,0,0,0.05), 7px 0 4px 0px rgba(0,0,0,0.05)',
      }
    },
    plainTextFeature: {
        fontSize: '0.9rem',
        fontWeight: 500,
        color: theme.palette.text.secondary,
        [theme.breakpoints.down(Sizes.mobile)]: {
          fontSize: 11,
        },
    },
    comingSoonText: {
        fontSize: '0.9rem',
        fontWeight: 500,
        color: theme.palette.info.main, // Use theme color
    },
    priorityChip: {
      position: 'absolute',
      top: 45,
      zIndex: 1,
      height: 14,
      width: '100%',
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomLeftRadius: 6,
      borderBottomRightRadius: 6,
      backgroundColor: '#FFF6D3',
      boxShadow: '-7px 0 4px 0px rgba(0,0,0,0.05), 7px 0 4px 0px rgba(0,0,0,0.05), 0 7px 4px 0px rgba(0,0,0,0.05)',
      border: '1px solid rgba(0, 0, 0, 0.12)',
      borderTop: 0,
   },
    bottomUpgradeSection: {
      textAlign: 'center',
      marginTop: theme.spacing(5),
      paddingBottom: theme.spacing(2),
    },
    bottomUpgradeText: {
        fontWeight: 600,
        marginBottom: theme.spacing(1.5),
    },
    keepFeaturesContainer: {
      textAlign: 'center',
      marginTop: 30,
    },
    keepFeaturesText: {
      marginBottom: 10,
      fontSize: 16,
      fontWeight: 700,
    }
  }),
);
